angular.module('bmsApp.settings').factory('SettingSvc', function ($http, $log, $window, $q, CRUDSvc) {
    var baseUrl = 'api/setting';
	return {
		index: function(params) {return CRUDSvc.get(baseUrl + '/index', params);},
		create: function (data) {return CRUDSvc.create(baseUrl + '/create', data);},
		update: function (data) {return CRUDSvc.update(baseUrl + '/update', data);},
		delete: function (data) {return CRUDSvc.update(baseUrl + '/delete', data);}
	}
});




